<!-- <div class="paginator-page-size">
  <div class="paginator-page-size-label">
  </div>
</div> -->

<div class="paginator-range-label">
  {{intl.getRangeLabel(pageIndex, pageSize, length)}}
</div>

<div class="paginator-range-actions">
  <button class="btn btn-outline-primary"
    type="button"
    [disabled]="previousButtonsDisabled()"
     (click)="previousPage()">
    <i class="fas fa-long-arrow-left"></i>
  </button>

  <div class="paginator-page-current">{{pageIndex + 1}}</div>

  <button class="btn btn-primary"
     type="button"
     [disabled]="nextButtonsDisabled()"
     (click)="nextPage()">
      {{intl.nextPageLabel}}
     <i class="fas fa-long-arrow-alt-right"></i>
    </button>


</div>